export default function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_isNumber.js
// module id = 451
// module chunks = 0